module.exports = __webpack_public_path__ + "static/media/sinkDestroyed.0d842e3e.png";